import React, { Component } from "react";
import Modal from "react-modal";
import ReactPlayer from "react-player/lazy";
import "styles/components/modal/video-modal.scss";

export default class VideoModal extends Component {
  render() {
    const { videoUrl, isOpen = false, closeModal } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        className="video-modal"
        overlayClassName="video-modal-overlay"
      >
        <div className="video-modal-container">
          {videoUrl && (
            <ReactPlayer
              url={videoUrl}
              controls
              className="video-player"
              width="100%"
              height="100%"
              config={{
                youtube: {
                  playerVars: {
                    modestbranding: 1,
                    rel: 0,
                    disablekb: 1,
                    showinfo: 0,
                  },
                },
              }}
            />
          )}
        </div>
      </Modal>
    );
  }
}
